import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RuleSearchesData } from "../../state/SearchManagerV2/RuleSearchesData";

const updateRuleSearchesV2Reducer: Reducer<RuleSearchesData> = (
  state: RuleSearchesData = new RuleSearchesData(),
  action: Action<ActionType, RuleSearchesData>
) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_FORM_UPDATED:
      return { ...state, ruleSearchesData: { ...state.ruleSearchesData, ...action.data } };
    case ActionType.SEARCH_MANAGER_V2_SEARCHES_FORM_RESET:
      const newState = new RuleSearchesData();
      return newState;
    default:
      return state;
  }
};

export default updateRuleSearchesV2Reducer;
